import {
  buildClientStoredName,
  isNamePartValid,
  isValidPhone,
  normalizeNamePart,
  normalizePhone,
  VALIDATION_PATTERNS,
} from '@minibook/shared';

export type BookingClientValidationInput = {
  firstName: string;
  lastName: string;
  middleName?: string;
  phoneE164: string;
  email?: string;
};

export type BookingClientValidationResult =
  | {
      ok: true;
      phoneForBackend: string;
      fullName: string;
    }
  | {
      ok: false;
      field: 'name' | 'phone' | 'email';
      code: 'name_required' | 'name_invalid' | 'phone_invalid' | 'email_invalid';
    };

export function validateBookingClientForm(
  input: BookingClientValidationInput
): BookingClientValidationResult {
  const firstNorm = normalizeNamePart(input.firstName);
  const lastNorm = normalizeNamePart(input.lastName);

  if (!firstNorm && !lastNorm) {
    return { ok: false, field: 'name', code: 'name_required' };
  }
  if (firstNorm && !isNamePartValid(input.firstName)) {
    return { ok: false, field: 'name', code: 'name_invalid' };
  }
  if (lastNorm && !isNamePartValid(input.lastName)) {
    return { ok: false, field: 'name', code: 'name_invalid' };
  }

  const phoneRaw = input.phoneE164.trim();
  if (!isValidPhone(phoneRaw)) {
    return { ok: false, field: 'phone', code: 'phone_invalid' };
  }

  const emailTrimmed = (input.email ?? '').trim();
  if (emailTrimmed && !VALIDATION_PATTERNS.EMAIL.test(emailTrimmed)) {
    return { ok: false, field: 'email', code: 'email_invalid' };
  }

  return {
    ok: true,
    phoneForBackend: normalizePhone(phoneRaw),
    fullName: buildClientStoredName({
      firstName: firstNorm,
      lastName: lastNorm,
      middleName: (input.middleName ?? '').trim(),
    }),
  };
}
